import { Modal, Row } from "antd";
import { ReactNode, useCallback, useMemo, useState } from "react";
import { InputMessage } from "../../../../../../Messages/components/Chat/components/InputMessage";
import { Chat } from "../../../../../../Messages/components/Chat";
import { useSend } from "../../../../../../Messages/components/Chat/hooks/useSend";
import "./styles.scss";
import { useReadConversation } from "../hooks/useReadConversation";
import { AbuseReport } from "../../../../../../Messages/components/AbuseReport";

type ChatModalProps = {
  isBuyer: boolean;
  open: boolean;
  accountNumber: number;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ChatModal = ({
  isBuyer,
  open,
  accountNumber,
  setOpen,
}: ChatModalProps) => {
  const [initErr, setInitErr] = useState<string | null>(null);

  const [initData, setInitData] = useState<any>(null);

  const [conversationId, setConversationId] = useState<string | undefined>(
    undefined,
  );

  const close = useCallback(() => {
    setOpen(false);
    setInitErr(null);
    setConversationId(undefined);
  }, [setOpen]);

  useReadConversation(conversationId);

  const {
    form,
    respose: mineNew,
    isSending,
    onMsgSent,
    send,
  } = useSend(conversationId);

  const title: ReactNode = useMemo(
    () => (
      <Row className="aling-center justify-space-between">
        <span>Chat with {isBuyer ? "Seller" : "Buyer"}</span>
        <Row className="align-center">
          {conversationId && <AbuseReport conversationId={conversationId} />}
          <Row className="vertical-devider ml-4" />
        </Row>
      </Row>
    ),
    [conversationId, isBuyer],
  );

  const showInput: boolean = useMemo(() => {
    if (initData) {
      return !initData.isClosed && !initData.isArchived;
    }

    return true;
  }, [initData]);

  const footer: ReactNode = useMemo(
    () =>
      initErr || !showInput ? (
        <Row />
      ) : (
        <InputMessage form={form} isSending={isSending} send={send} />
      ),
    [form, isSending, initErr, showInput, send],
  );

  return (
    <Modal
      open={open}
      onCancel={close}
      title={title}
      width={1000}
      className="bordered-modal chat-modal"
      footer={footer}
      destroyOnClose
    >
      <Chat
        isArchived={initData?.isArchived || false}
        initErr={initErr}
        contractNumber={accountNumber}
        conversationId={conversationId}
        setConversationId={setConversationId}
        setInitErr={setInitErr}
        mineNew={mineNew}
        onMsgSent={onMsgSent}
        setInitData={setInitData}
      />
    </Modal>
  );
};
